export default "__VITE_ASSET__DU1o6KYQ__"